import dayjs from "dayjs";

function getInitialValues(formField) {
  let initialValues = {};
  for (const field in formField) {
    switch (formField[field].type) {
      case "text":
      case "select":
      case "date":
      case "datetime":
        initialValues[field] = null;
        break;
      case "number":
        initialValues[field] = 0;
        break;
      case "switch":
        initialValues[field] = formField[field].default ?? false;
        break;
      case "file":
        initialValues[field] = [];
        break;
      case "multi-select":
        initialValues[field] = [];
        break;
      default:
        initialValues[field] = "";
    }
  }
  return initialValues;
}

function convertDateTimeFormat(date) {
  if (!Boolean(date)) return "";
  return dayjs(date).format("DD/MM/YYYY HH:mm:ss");
}

function convertDateFormat(date) {
  if (!Boolean(date)) return "";
  return dayjs(date).format("DD/MM/YYYY");
}

function filterDateTimeFn(row, id, data) {
  if (!Boolean(data)) return true;
  const value = dayjs(row.original[id]).format("DD/MM/YYYY HH:mm:ss");
  return value.includes(data);
}

function filterDateFn(row, id, data) {
  if (!Boolean(data)) return true;
  const value = dayjs(row.original[id]).format("DD/MM/YYYY");
  return value.includes(data);
}

function sortingDateFn(rowA, rowB, columnId) {
  const parseDate = (dateString) => {
    if (!dateString) return null
    const [day, month, year] = dateString.split(/[/ ]/);
    return new Date(year, month - 1, day);
  };

  const dateA = parseDate(rowA.original[columnId]);
  const dateB = parseDate(rowB.original[columnId]);

  if (isNaN(dateA) && isNaN(dateB)) return 0;
  if (isNaN(dateA)) return 1;
  if (isNaN(dateB)) return -1;

  return dateA - dateB;
}

function sortingDateTimeFn(rowA, rowB, columnId){
  const parseDate = (dateString) => {
    if (!dateString) return null
    const [day, month, year, time] = dateString.split(/[/ ]/);
    const [hours, minutes, seconds] = time.split(':');
    return new Date(year, month - 1, day, hours, minutes, seconds);
  };

  const dateA = parseDate(rowA.original[columnId]);
  const dateB = parseDate(rowB.original[columnId]);

  if (isNaN(dateA) && isNaN(dateB)) return 0;
  if (isNaN(dateA)) return 1;
  if (isNaN(dateB)) return -1;

  return dateA - dateB;
}

function sortingDateYMDFn(rowA, rowB, columnId) {
  const parseDate = (dateString) => {
    if (!dateString) return null
    const [year, month, day] = dateString.split(/[/ ]/);
    return new Date(year, month - 1, day);
  };

  const dateA = parseDate(rowA.original[columnId]);
  const dateB = parseDate(rowB.original[columnId]);

  if (isNaN(dateA) && isNaN(dateB)) return 0;
  if (isNaN(dateA)) return 1;
  if (isNaN(dateB)) return -1;

  return dateA - dateB;
}

function sortingDateTimeYMDFn(rowA, rowB, columnId){
  const parseDate = (dateString) => {
    if (!dateString) return null
    const [year, month, day, time] = dateString.split(/[/ ]/);
    const [hours, minutes, seconds] = time.split(':');
    return new Date(year, month - 1, day, hours, minutes, seconds);
  };

  const dateA = parseDate(rowA.original[columnId]);
  const dateB = parseDate(rowB.original[columnId]);

  if (isNaN(dateA) && isNaN(dateB)) return 0;
  if (isNaN(dateA)) return 1;
  if (isNaN(dateB)) return -1;

  return dateA - dateB;
}

function sortingTimeSpanFn(rowA, rowB, columnId){
  const extractTimeValues = (timeString) =>  {
    const timeParts = { days: 0, hours: 0, minutes: 0 };

    timeString.split(", ").forEach(part => {
        if (part.includes("day")) timeParts.days = parseInt(part);
        if (part.includes("hour")) timeParts.hours = parseInt(part);
        if (part.includes("minute")) timeParts.minutes = parseInt(part);
    });

    return timeParts;
}

  const dateA = extractTimeValues(rowA.original[columnId]);
  const dateB = extractTimeValues(rowB.original[columnId]);

  if (!Boolean(dateA) && !Boolean(dateB)) return 0;
  if (!Boolean(dateA)) return 1;
  if (!Boolean(dateB)) return -1;

  if (dateA.days !== dateB.days) return dateB.days - dateA.days;
  if (dateA.hours !== dateB.hours) return dateB.hours - dateA.hours;
  return dateB.minutes - dateA.minutes;
}

export {
  getInitialValues,
  convertDateTimeFormat,
  convertDateFormat,
  filterDateTimeFn,
  filterDateFn,
  sortingDateFn,
  sortingDateTimeFn,
  sortingDateYMDFn,
  sortingDateTimeYMDFn,
  sortingTimeSpanFn,
};
